package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.model.EventContent
import fr.manyverse.app.domain.model.EventType
import fr.manyverse.app.domain.repository.GameEventRepository
import fr.manyverse.app.domain.repository.GameTableRepository

class KickPlayerUseCase(
    private val gameTableRepository: GameTableRepository,
    private val gameEventRepository: GameEventRepository
) {
    suspend operator fun invoke(
        tableId: String,
        userId: String,
        triggeredBy: String
    ): Result<Unit> {
        // Emit the event BEFORE removal so the player can receive it via Realtime
        gameEventRepository.createEvent(
            tableId = tableId,
            type = EventType.PLAYER_KICKED,
            triggeredBy = triggeredBy,
            targetParticipants = listOf(userId),
            content = EventContent.PlayerKicked()
        ).onFailure { return Result.failure(it) }

        return gameTableRepository.kickMember(tableId, userId)
    }
}
